var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-content mb-4"},[_c('div',{staticClass:"tile-content-header"},[_c('h3',{staticClass:"text-uppercase"},[_vm._v(" "+_vm._s(_vm.$t('invoices.tracking.dhlNumber'))+" ")]),_c('small',{staticClass:"text-uppercase"},[_c('b-icon-hash'),_vm._v(" "+_vm._s(_vm.dhlNumber)+" ")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }